
import http from '../api'
import Vue from 'vue'

// initial state
const state = {
  wxToken:Vue.ls.get('ssToken')?Vue.ls.get('ssToken'):"",
  wxOpenId:Vue.ls.get('ssOpenId')?Vue.ls.get('ssOpenId'):""
  //wxToken:Vue.ls.get('ssToken')?Vue.ls.get('ssToken'):"a36d6d65-6c0b-4706-a7b3-c0468c4a5e90",
  //wxOpenId:Vue.ls.get('ssOpenId')?Vue.ls.get('ssOpenId'):"oW0WhwZ_Uj_fQCWbcIxU2hvSjiQQ"
}

// getters
const getters = {}

const getWxToken = (commit ) => {
  return new Promise((s)=>{
    http.get(`aocampaign/openapi/wxmp/web-page-token/${Vue.ss.get('ssCode')}`).then(
      (res) => { 
        console.log('store里面获取个人信息的接口', res.data)
        if(res.data){
          if(res.data.access_token){
            Vue.ls.set('ssToken', res.data['access_token'])
            commit('setWxToken', res.data['access_token'])
          }
          Vue.ls.set('ssOpenId', res.data['openId'])
          commit('setWxOpenId', res.data['openId'])
          Vue.ss.remove("ssCode")
          s(res.data)
        }
       
      }
    ).catch((err) => {
      Vue.ss.remove("ssCode")
      if(err.message.includes('400')) {
        initWxGetToken()
      }else{
        s()
      }
    })
  })
}

const initWxGetToken = async function() {
  // let url = window.location.href
  // let code = share.getUrlParam(window.location.href,'code')
  // const type = share.getUrlParam(window.location.href,'type')
  // const appid = share.getUrlParam(window.location.href,'appid')
  // if(!code) {
  //   url = window.location.href.replace('&code=','')
  // }
  // code = share.getUrlParam(url,'code')
  // if(code) {
  //   url = window.location.href.replace('&code='+code,'')
  // }
  // url = url.replace('&code=','')
  // if(!type && !appid) {
  //   const href = url.split('?')
  //   url = href.length > 1 ? (url + '&type=161&appid=wx6c1fa6673a17c2d8'): (url.split('?')[0] + '?type=161&appid=wx6c1fa6673a17c2d8')
  // }
  // console.log('env', env.env)
  // url = encodeURIComponent(url)
  let urlLogin= await login()
    urlLogin=urlLogin.replace('#','%23')
    let activityUrlNum= Vue.ls.get('AO_APP_ACTIVITY_URL_NUM_H5')
    var ua= window.navigator.userAgent.toLowerCase();
    if( (ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork') ){
     window.location.replace(urlLogin)
    }else{
       if(activityUrlNum&&activityUrlNum>0){
         activityUrlNum++;
         Vue.ls.set('AO_APP_ACTIVITY_URL_NUM_H5',activityUrlNum)
       }else{
         activityUrlNum=1
         Vue.ls.set('AO_APP_ACTIVITY_URL_NUM_H5',activityUrlNum)
       }
     
       if(activityUrlNum>3){
         Vue.ls.remove('AO_APP_ACTIVITY_URL_NUM_H5')
         alert('授权失败')
       }else{
         window.location.replace(urlLogin)
       }
    }
}
const initUserInfoWxGetToken= async function(){
  let urlLogin= await userInfologin()
  urlLogin=urlLogin.replace('#','%23')
   let activityUrlNum= Vue.ls.get('AO_APP_ACTIVITY_URL_NUM_H5')
   var ua= window.navigator.userAgent.toLowerCase();
   if( (ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork') ){
    window.location.replace(urlLogin)
   }else{
      if(activityUrlNum&&activityUrlNum>0){
        activityUrlNum++;
        Vue.ls.set('AO_APP_ACTIVITY_URL_NUM_H5',activityUrlNum)
      }else{
        activityUrlNum=1
        Vue.ls.set('AO_APP_ACTIVITY_URL_NUM_H5',activityUrlNum)
      }
    
      if(activityUrlNum>3){
        Vue.ls.remove('AO_APP_ACTIVITY_URL_NUM_H5')
        alert('授权失败')
      }else{
        window.location.replace(urlLogin)
      }
   }


}
//静默授权
let login =  function(){
  let arU=window.location.href
   let ar = arU.split('#/')
  let redirectUri=Vue.ss.get('redirectUri')
  let state=Vue.ss.get('pageState')?Vue.ss.get('pageState'):""
  return new Promise((s) => {
    http.get(`aocampaign/openapi/user/base-auth-url?redirectUrl=${encodeURIComponent(ar[0]+'#/'+redirectUri)}&state=${state}`).then(
      (res) => {
        s(res.data)
      }
    ).catch(() => {
      
    })
  })
}
//获取用户信息
let userInfologin =  function(){
  let arU=window.location.href
   let ar = arU.split('#/')
  let redirectUri=Vue.ss.get('redirectUri')
  return new Promise((s) => {
    http.get(`aocampaign/openapi/user/auth-url?redirectUrl=${encodeURIComponent(ar[0]+'#/'+redirectUri)}`).then(
      (res) => {
        s(res.data)
      }
    ).catch(() => {
      
    })
  })
}
// actions
const actions = {
  wxLogin({commit}) {
    return new Promise((s)=>{
      if(!state.wxOpenId){
        let ssCode=Vue.ss.get('ssCode')
        if(ssCode) {
          setTimeout(async()=>{
            let token=await getWxToken(commit)
            if(token){
              s(token)
            }
          },100)
        } else {
          setTimeout(async()=>{
            await initWxGetToken()
          },100)
        }
      }else{
        //获取用户基本信息
        let wxUserInfoLogin=Vue.ss.get('wxUserInfoLogin')
        if(wxUserInfoLogin&&wxUserInfoLogin==='wxUserInfoLogin'){
          let ssCode=Vue.ss.get('ssCode')
          if(ssCode) {
            setTimeout(async()=>{
              let token=await getWxToken(commit)
              Vue.ss.remove("wxUserInfoLogin")
              if(token){
                s(token)
              }
            },100)
          } else {
            setTimeout(async()=>{
              await initWxGetToken()
            },100)
          }
        }else{
          console.log('state.wxOpenId----:',state.wxOpenId);
          
          // setTimeout(async () => {
					// 	await initWxGetToken()
					// }, 100)
          s(state.wxOpenId)
        }
      }
      
    })
  },
  wxUserInfoLogin({commit}) {
    return new Promise((s)=>{
      if(!Vue.ls.get('ssToken')){
        let ssCode=Vue.ss.get('ssCode')
        if(ssCode){
          setTimeout(async()=>{
            let token=await getWxToken(commit)
            if(token){
              s(token)
            }
          },100)
        } else {
          setTimeout(async()=>{
            await initUserInfoWxGetToken()
          },100)
        }
      }else{
        s(state.wxToken)
      }
      
    })
  },
  getWxToken({ commit }) {
    return new Promise((s)=>{
      http.get(`aocampaign/openapi/wxmp/web-page-token/${Vue.ss.get('ssCode')}`).then(
        (res) => { 
          if(res.data){
            if(res.data.access_token){
              Vue.ls.set('ssToken', res.data['access_token'])
              commit('setWxToken', res.data['access_token'])
            }
            Vue.ls.set('ssOpenId', res.data['openId'])
            commit('setWxOpenId', res.data['openId'])
            Vue.ss.remove("ssCode")
            Vue.ls.remove('AO_APP_ACTIVITY_URL_NUM_H5')
            s(res.data)
          }
        }
      ).catch((err) => {
        s()
        console.log('err', err)
      })
    })
  },
  //行为日志
  getLogSave({commit},{targetId,shareId,targetType}){
      return new Promise((s) => {
        let id=targetId?`&targetId=${targetId}`:'';
        http
          .get(`aocampaigncallingcard/openapi/customer/callingcard/logSave/${shareId}?openId=${Vue.ls.get('ssOpenId')}&targetType=${targetType}${id}`)
          .then(() => {
            console.log('commit',commit)
            s()
          })
        })
  },
  //判断token 
  getCheckToken({ commit }){
      return new Promise((s)=>{
         if(Vue.ls.get("ssToken")){
          http
            .get(`aocampaigncallingcard/openapi/customer/callingcard/check-token`)
            .then((res) => {
              if(res.data){
                  Vue.ls.remove("ssToken")
                  Vue.ls.remove('ssOpenId')
                  commit('setWxToken', '')
                  commit('setWxCode', '')
                  window.location.reload();
                  // s(false)
              }else{
                s(true)
              }
            })
          }else{
            s(true)
          }
      })
  }
}

// mutations
const mutations = {
  setWxToken(state, data) {
    state.wxToken = data
  },
  setWxOpenId(state, data) {
    state.wxOpenId = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
